import SecuredLayout from "../components/SecuredLayout";
import Dashboard from "../pages/Dashboard";
import UserRegistration from "../pages/Admin/UserRegistration";
// import Customers from "../pages/Admin/Customers";
import ListVibhags from "../pages/Admin/ListVibhags";
import ListJilla from "../pages/Admin/ListJilla";
import ListKhands from "../pages/Admin/ListKhands";
import ListMandalam from "../pages/Admin/ListMandalam";
import ListSthan from "../pages/Admin/ListSthan";
import ListArthikSakhas from "../pages/Admin/ListArthikSakhas";
import Get_email_otp from "../pages/Admin/Get_email_otp";
import Get_email_otp2 from "../pages/Get_email_otp2";
import ListSthansInArthikSakha from "../pages/Admin/ListSthansInArthikSakha";
import ArthiksakhaAddSthanUser from "../pages/Admin/ArthiksakhaAddSthanUser";
import AdminAddUser from "../pages/Admin/AdminAddUser";

import AdminAddSthanUser from "../pages/Admin/AdminAddSthanUser";
import ListArthikSakhaOfThisUser from "../pages/Admin/ListArthikSakhaOfThisUser";
import ListSthanUsers from "../pages/Admin/ListSthanUsers";
import SthanAddGurudakshina from "../pages/Admin/SthanAddGurudakshina";
import ArthiksakhaDashboard from "../pages/ArthiksakhaDashboard";
import SthanUserAddCategories from "../pages/SthanUserAddCategories";
import ListGurudakshinaInSthan from "../pages/Admin/ListGurudakshinaInSthan";
import ViewGurudakshina from "../pages/Admin/ViewGurudakshina";
import ListGurudakshinaInArthiksakha from "../pages/Admin/ListGurudakshinaInArthiksakha";
import SthanEditGurudakshina from "../pages/Admin/SthanEditGurudakshina";
import AdminEditGurudakshina from "../pages/Admin/AdminEditGurudakshina";
import ArthiksakhaEditGurudakshina from "../pages/Admin/ArthiksakhaEditGurudakshina";


import AdminVibhagSummary from "../pages/Admin/AdminVibhagSummary";
import AdminListGurudakshina from "../pages/Admin/AdminListGurudakshina";
import ArthiksakhasListGurudakshina from "../pages/Admin/ArthiksakhasListGurudakshina";
import AdminSearchUser from "../pages/Admin/AdminSearchUser";
import AdminAddSthanToUser from "../pages/Admin/AdminAddSthanToUser";
import AdminAddVibhagToUser from "../pages/Admin/AdminAddVibhagToUser";
import AdminAddJillaToUser from "../pages/Admin/AdminAddJillaToUser";
import AdminAddKhandToUser from "../pages/Admin/AdminAddKhandToUser";

import AdminAddArthiksakhaToUser from "../pages/Admin/AdminAddArthiksakhaToUser";

import ArthiksakhaAddSthanToUser from "../pages/Admin/ArthiksakhaAddSthanToUser";

import ListKhandShreniWiseSummary from "../pages/Admin/ListKhandShreniWiseSummary";
import AddVibhag from "../pages/Admin/AddVibhag";
import ChangeSthanUserPswd from "../pages/Admin/ChangeSthanUserPswd";
import AdminChangeSthanUserPswd from "../pages/Admin/AdminChangeSthanUserPswd";
import AdminGurudakshinaSummary from "../pages/Admin/AdminGurudakshinaSummary";
import ArthikSakhaGurudakshinaSummary from "../pages/Admin/ArthikSakhaGurudakshinaSummary";
import ArthiksakhaListGurudakshinaInSthan from "../pages/Admin/ArthiksakhaListGurudakshinaInSthan";
import ArthikSakhaAddGurudakshina from "../pages/Admin/ArthikSakhaAddGurudakshina";
import AdminListGurudakshinaInSthan from "../pages/Admin/AdminListGurudakshinaInSthan";
import AdminAddGurudakshina from "../pages/Admin/AdminAddGurudakshina";
import ArthikSakhasSearchUser from "../pages/Admin/ArthikSakhasSearchUser";
import ArthiksakhasSthanShreniWiseSummary from "../pages/Admin/ArthiksakhasSthanShreniWiseSummary";
import AdminSthanShreniWiseSummary from "../pages/Admin/AdminSthanShreniWiseSummary";
import AdminKhandShreniWiseSummary from "../pages/Admin/AdminKhandShreniWiseSummary";
import AdminJillaSummary from "../pages/Admin/AdminJillaSummary";
import AdminArthiksakhaSummary from "../pages/Admin/AdminArthiksakhaSummary";

import ArthiksakhaKhandShreniWiseSummary from "../pages/Admin/ArthiksakhaKhandShreniWiseSummary";

import AdminKhandArppanDetails from "../pages/Admin/AdminKhandArppanDetails";

import UpdateSthanUser from "../pages/Admin/UpdateSthanUser";
import AdminListSthansInArthikSakha from "../pages/Admin/AdminListSthansInArthikSakha";
import ListSthanUsersInArthikSakha from "../pages/Admin/ListSthanUsersInArthikSakha";
import AdminListSthanUsersInArthikSakha from "../pages/Admin/AdminListSthanUsersInArthikSakha";
import ListKhandsInArthikSakha from "../pages/Admin/ListKhandsInArthikSakha";
import DefaultSthan from "../pages/Admin/DefaultSthan";
import DefaultArthiksakha from "../pages/Admin/DefaultArthiksakha";

import SthanDashboard from "../pages/SthanDashboard";


import Missing from "../pages/Missing";
import Unauthorized from "../pages/Unauthorized";
import Home from "../pages/Home";
import Login from "../pages/Login";
import PersistLogin from "../components/PersistLogin";

import ListUsers from "../pages/Admin/ListUsers";

import JillaUthsavamReport from "../pages/Admin/JillaUthsavamReport";

import PranthUthsavamReport from "../pages/Admin/PranthUthsavamReport";



import ArthiksakhaJillaUthsavamReport from "../pages/Admin/ArthiksakhaJillaUthsavamReport";

import JillaUthsavamReportPDF from "../pages/Admin/JillaUthsavamReportPDF";

import JillaUthsavamShreniReport from "../pages/Admin/JillaUthsavamShreniReport";

import PranthUthsavamShreniReport from "../pages/Admin/PranthUthsavamShreniReport";

import ArthiksakhaJillaUthsavamShreniReport from "../pages/Admin/ArthiksakhaJillaUthsavamShreniReport";


const MyRoutes = [
  {
    path: "/",
    title: "Home",
    element: <Home />,
    errorElement: <Missing />,
  },
  {
    path: "login",
    element: <Login />,
    title: "Login",
  },
  {
    path: "register",
    element: <Get_email_otp2 />,
    title: "Get_email_otp2",
  },
  {
    path: "unauthorized",
    title: "",
    element: <Unauthorized />,
  },
  {
    // secured routes
    element: <PersistLogin />,
    secured: true,
    children: [
      {
        path: "/",
        element: <SecuredLayout />,
        //   secured: true,
        children: [
          {
            // index: true,
            path: "/dashboard",
            title: "Dashboard",
            //    secured: true,
            element: <Dashboard />,
            roles: ["Arthiksakha", "Admin", "Sthan"]
          },
          {
            index: true,
            path: "/ArthiksakhaDashboard",
            title: "Arthiksakha Dashboard",
            //    secured: true,
            element: <ArthiksakhaDashboard />,
            roles: ["Arthiksakha"]
          },
          {
            index: true,
            path: "/sthan/add/categories",
            // title: "Arthiksakha Dashboard",
            //    secured: true,
            element: <SthanUserAddCategories />,
            roles: ["Arthiksakha", "Admin", "Sthan"]
          },


          // {
          //   group: "Administration",
          //   path: "registeruser",
          //   title: "Register User",
          //   //     secured: true,
          //   element: <UserRegistration />,
          //   roles: ["Admin"]
          // },

          {
            group: "Administration",
            path: "admin/add/user",
            //      secured: true,
            title: "Add User",
            element: <AdminAddUser />,
            roles: ["Admin"]
          },


          {
            group: "Administration",
            path: "arthiksakha/add/AddSthanUser",
            //      secured: true,
            title: "Add Sthan User",
            element: <ArthiksakhaAddSthanUser />,
            roles: ["Arthiksakha"]
          },

          // {
          //   group: "Administration",
          //   path: "admin/add/AddSthanUser",
          //   //      secured: true,
          //   title: "Add Sthan User",
          //   element: <AdminAddSthanUser />,
          //   roles: ["Admin"]
          // },

          {
            group: "Administration",
            path: "admin/search/user",
            //      secured: true,
            title: "Search user",
            element: <AdminSearchUser />,
            roles: ["Admin"]
          },
          {
            group: "Administration",
            path: "arthiksakha/search/user",
            //      secured: true,
            title: "Search Sthan user",
            element: <ArthikSakhasSearchUser />,
            roles: ["Arthiksakha"]
          },
          {
            group: "Administration",
            path: "/list/sthanUsersInArthikSakha",
            title: "Active Sthan Users",
            element: <ListSthanUsersInArthikSakha />,
            roles: ["Arthiksakha"]
          },

          {
            group: "Administration",
            path: "list/vibhags",
            //      secured: true,
            title: "Vibhags List",
            element: <ListVibhags />,
            roles: ["Admin"]
          },
          {
            group: "Administration",
            path: "list/jilla",
            //      secured: true,
            title: "Jilla List",
            element: <ListJilla />,
            roles: ["Admin"]
          },
          {
            group: "Administration",
            path: "list/khands",
            //      secured: true,
            title: "Khands List",
            element: <ListKhands />,
            roles: ["Admin"]
          },
          {
            group: "Administration",
            path: "list/mandalam",
            //      secured: true,
            title: "Mandalam List",
            element: <ListMandalam />,
            roles: ["Admin"]
          },

          {
            group: "Administration",
            path: "admin/list/sthan",
            //      secured: true,
            title: "Sthan List",
            element: <ListSthan />,
            roles: ["Admin"]
          },
          {
            group: "Administration",
            path: "admin/list/users",
            //      secured: true,
            title: "List Users",
            element: <ListUsers />,
            roles: ["Admin"]
          },
          {
            group: "Administration",
            path: "list/arthiksakhas",
            //      secured: true,
            title: "Arthiksakhas",
            element: <ListArthikSakhas />,
            roles: ["Admin"]
          },


          {
            group: "Administration",
            path: "list/ArthikSakhaOfThisUser",
            //      secured: true,
            // title: "List ArthikSakhas",
            element: <ListArthikSakhaOfThisUser />,
            roles: ["Arthiksakha"]
          },
          {
            group: "Administration",
            path: "/sthan/users/:SthanId/:SthanName",
            element: <ListSthanUsers />,
            roles: ["Admin", "Arthiksakha"],
          },
          {
            group: "Gurudakshina",
            path: "admin/list/gurudakshina",
            //      secured: true,
            title: "Gurudakshina List",
            element: <AdminListGurudakshina />,
            roles: ["Admin"]
          },
          {
            group: "Gurudakshina",
            path: "arthiksakha/list/gurudakshina",
            //      secured: true,
            title: "Gurudakshina List",
            element: <ArthiksakhasListGurudakshina />,
            roles: ["Arthiksakha"]
          },
          {
            group: "Gurudakshina",
            path: "/add/gurudakshina",
            title: "Add Gurudakshina",
            element: <SthanAddGurudakshina />,
            roles: ["Sthan"]
          },
          {
            group: "Gurudakshina",
            path: "/list/gurudakshinainsthan",
            title: "List Gurudakshina In Sthan",
            element: <ListGurudakshinaInSthan />,
            roles: ["Sthan"]
          },
          {
            group: "Administration",
            path: "/view/gurudakshina/:Id",
            element: <ViewGurudakshina />,
            roles: ["Sthan", "Arthiksakha", "Admin"],
          },


          {
            group: "Administration",
            path: "sthan/edit/gurudakshina/:Id",
            element: <SthanEditGurudakshina />,
            roles: ["Sthan"],
          },

          {
            group: "Administration",
            path: "/sthanDashboard",
            element: <SthanDashboard />,

            roles: ["Arthiksakha", "Admin", "Sthan"]
          },
          {
            group: "Administration",
            title: "List Khands",
            path: "/list/KhandsInArthikSakha",
            element: <ListKhandsInArthikSakha />,
            roles: ["Arthiksakha"]
          },
          {
            group: "Administration",
            path: "list/arthiksakha_sthans",
            //      secured: true,
            title: "List Sthans",
            element: <ListSthansInArthikSakha />,
            roles: ["Arthiksakha"]
          },
          {
            group: "Administration",
            path: "/list/KhandSummary/:Id/:Name",
            element: <ListKhandShreniWiseSummary />,
            roles: ["Sthan", "Arthiksakha"],
          },
          {
            group: "Administration",
            path: "/default/sthan/",
            title: "Settings",
            element: <DefaultSthan />,
            roles: ["Sthan"]
          },
          {
            group: "Administration",
            path: "/default/arthiksakha/",
            title: "Settings",
            element: <DefaultArthiksakha />,
            roles: ["Arthiksakha"]
          },
          // {
          //   group: "Administration",
          //   path: "/add/vibhag/",
          //   title: "Add vibhag",
          //   element: <AddVibhag />,
          //   roles: ["Admin"]
          // },
          {
            group: "Administration",
            path: "/change/SthanUserPswd/:Id/:Name",
            element: <ChangeSthanUserPswd />,
            roles: ["Admin", "Arthiksakha"]
          },
          {
            group: "Administration",
            path: "/admin/change/SthanUserPswd/:Id/:Name",
            element: <AdminChangeSthanUserPswd />,
            roles: ["Admin", "Arthiksakha"]
          },
          {
            group: "Administration",
            path: "/update/sthanUser/:personId/:Name/:Mobile/:Responsibility",
            element: <UpdateSthanUser />,
            roles: ["Admin", "Arthiksakha"]
          },

          {
            group: "Administration",
            path: "/Admin/listSthans/InArthikSakha/:Id",
            element: <AdminListSthansInArthikSakha />,
            roles: ["Admin"]
          },
          {
            group: "Administration",
            path: "/admin/list/sthanUsersInArthikSakha/:Id",
            element: <AdminListSthanUsersInArthikSakha />,
            roles: ["Admin"]
          },


          // {
          //   group: "Administration",
          //   path: "/list/gurudakshinainarthiksakha",
          // title: "List Gurudakshina ",
          //   element: <ListGurudakshinaInArthiksakha />,
          //   roles: ["Arthiksakha"]
          // },

          {
            group: "Administration",
            path: "/arthikShakha/list/GurudakshinaInSthan/:Id/:Name",
            element: <ArthiksakhaListGurudakshinaInSthan />,
            roles: ["Arthiksakha"]
          },

          {
            group: "Administration",
            path: "/arthikShakha/add/gurudakshina/:Id/",
            element: <ArthikSakhaAddGurudakshina />,
            roles: ["Arthiksakha"]
          },

          {
            group: "Administration",
            path: "/admin/list/GurudakshinaInSthan/:Id/:Name",
            element: <AdminListGurudakshinaInSthan />,
            roles: ["Admin"]
          },
          {
            group: "Administration",
            path: "/admin/add/gurudakshina/:Id/",
            element: <AdminAddGurudakshina />,
            roles: ["Admin"]
          },

          {
            group: "Administration",
            path: "admin/edit/gurudakshina/:gurudakshinaId/:sthanId",
            element: <AdminEditGurudakshina />,
            roles: ["Admin"]
          },

          {
            group: "Administration",
            path: "/arthiksakha/edit/gurudakshina/:gurudakshinaId/:sthanId",
            element: <ArthiksakhaEditGurudakshina />,
            roles: ["Arthiksakha"],
          },
          {
            group: "Gurudakshina",
            path: "admin/list/VibhagSummary",
            //      secured: true,
            title: "Vibhag Summary",
            element: <AdminVibhagSummary />,
            roles: ["Admin"]
          },

          {
            group: "Gurudakshina",
            path: "admin/list/JillaSummary",
            //      secured: true,
            title: "Jilla Summary",
            element: <AdminJillaSummary />,
            roles: ["Admin"]
          },

          {
            group: "Gurudakshina",
            path: "admin/list/SthanSummary",
            //      secured: true,
            title: "Sthan Summary",
            element: <AdminSthanShreniWiseSummary />,
            roles: ["Admin"]
          },
          {
            group: "Gurudakshina",
            path: "admin/list/ArthiksakhaSummary",
            //      secured: true,
            title: "Arthiksakha Summary",
            element: <AdminArthiksakhaSummary />,
            roles: ["Admin"]
          },
          {
            group: "Gurudakshina",
            title: "Gurudakshina Summary Report",
            path: "/admin/list/GurudakshinaSummary/",
            element: <AdminGurudakshinaSummary />,
            roles: ["Admin"]
          },

          {
            group: "Gurudakshina",
            path: "admin/list/KhandArppanDetails",
            //      secured: true,
            // title: "Khand Arppan Details",
            element: <AdminKhandArppanDetails />,
            roles: ["Admin"]
          },







          {
            group: "Administration",
            path: "admin/add/SthanToUser",
            element: <AdminAddSthanToUser />,
            roles: ["Admin"]
          },

          {
            group: "Administration",
            path: "admin/add/vibhagToUser",
            element: <AdminAddVibhagToUser />,
            roles: ["Admin"]
          },
          {
            group: "Administration",
            path: "admin/add/jillaToUser",
            element: <AdminAddJillaToUser />,
            roles: ["Admin"]
          },
          {
            group: "Administration",
            path: "admin/add/khandToUser",
            element: <AdminAddKhandToUser />,
            roles: ["Admin"]
          },


          {
            group: "Administration",
            path: "admin/add/ArthiksakhaToUser",
            element: <AdminAddArthiksakhaToUser />,
            roles: ["Admin"]
          },

          {
            group: "Administration",
            path: "arthiksakha/add/SthanToUser",
            element: <ArthiksakhaAddSthanToUser />,
            roles: ["Arthiksakha"]
          },



          {
            group: "Gurudakshina",
            path: "arthiksakha/list/KhandSummary",
            //      secured: true,
            title: "Khand Summary",
            element: <ArthiksakhaKhandShreniWiseSummary />,
            roles: ["Arthiksakha"]
          },

          {
            group: "Gurudakshina",
            path: "arthiksakha/list/SthanSummary",
            //      secured: true,
            title: "Sthan Summary",
            element: <ArthiksakhasSthanShreniWiseSummary />,
            roles: ["Arthiksakha"]
          },


          {
            group: "Gurudakshina",
            path: "/arthiksakha/list/GurudakshinaSummary/",
            title: "Gurudakshina Summary Report",
            element: <ArthikSakhaGurudakshinaSummary />,
            roles: ["Arthiksakha"]
          },

          {
            group: "Gurudakshina",
            path: "admin/list/PranthUthsavamReport",
            //      secured: true,
            title: "Pranth Uthsavam Report",
            element: <PranthUthsavamReport />,
            roles: ["Admin"]
          },

          {
            group: "Gurudakshina",
            path: "admin/list/PranthUthsavamShreniReport",
            //      secured: true,
            title: "Pranth Uthsavam Shreni Report",
            element: <PranthUthsavamShreniReport />,
            roles: ["Admin"]
          },



          {
            group: "Gurudakshina",
            path: "admin/list/JillaUthsavamReport",
            //      secured: true,
            title: "Jilla Uthsavam Report",
            element: <JillaUthsavamReport />,
            roles: ["Admin"]
          },
          {
            group: "Gurudakshina",
            path: "arthiksakha/list/jillaUthsavamReport",
            //      secured: true,
            title: "Jilla Uthsavam Report",
            element: <ArthiksakhaJillaUthsavamReport />,
            roles: ["Arthiksakha"]
          },


          // {
          //   group: "Gurudakshina",
          //   path: "admin/list/JillaUthsavamReportPDF",
          //   //      secured: true,
          //   title: "Jilla Uthsavam Report PDF",
          //   element: <JillaUthsavamReportPDF />,
          //   roles: ["Admin"]
          // },

          {
            group: "Gurudakshina",
            path: "admin/list/JillaUthsavamShreniReport",
            //      secured: true,
            title: "Jilla Uthsavam Shreni Report",
            element: <JillaUthsavamShreniReport />,
            roles: ["Admin"]
          },





          {
            group: "Gurudakshina",
            path: "arthiksakha/list/jillaUthsavamShreniReport",
            //      secured: true,
            title: "Jilla Uthsavam Shreni Report",
            element: <ArthiksakhaJillaUthsavamShreniReport />,
            roles: ["Arthiksakha"]
          },




        ],
      },
    ],
  },
];

export default MyRoutes;
